const compareParameter = [
    {
        key: 0,
        name: 'booking_options',
        value: true,
        heading: "WAREHOUSE  AVAILABILITY",
        textual: true,
        column: 3,
    },
    {
        key: 1,
        name: 'brokerage',
        value: true,
        heading: "Brokerage",
        textual: true,
        column: 3,

    },
    {
        key: 2,
        name: 'warehouse_capacity',
        value: true,
        heading: "WAREHOUSE CAPACITY",
        textual: true,
        column: 4
    },
    {
        key: 3,
        name: 'accessibility',
        value: true,
        heading: "ACCESSIBILITY",
        textual: true,
        column: 4,

    },
    {
        key: 4,
        name: 'warehouse_structure',
        value: true,
        heading: "WAREHOUSE STRUCTURE",
        textual: true,
        column: 4,

    },
    {
        key: 5,
        name: 'amenities',
        value: true,
        heading: "AMENITIES",
        textual: false,
        column: 4
    },
    {
        key: 6,
        name: 'license',
        value: true,
        heading: "LICENSE",
        textual: false,
        column: 4
    },
    {
        key: 7,
        name: 'weighbridge',
        value: true,
        heading: "WEIGHBRIDGE",
        textual: true,
        column: 4
    },
];

const keyName = {
    // WAREHOUSE CAPACITY
    area_in_sqft: 'Area',
    warehouse_capacity: 'Capacity',
    no_of_bags: 'No. Bags (50 kg per bag)',
    dimensions: 'Area(l*b*h)',

    // ACCESSIBILTY
    apmc_name: 'Closet APMC and its distance',
    rakepoint_name: 'Rake point and distance',
    apmc_under_40_km: 'No. of AMPC (Under 40kms Radius)',
    railway_station_distance: 'Nearest Railway Station',
    fire_station_distance: 'Nearest Fire Station',
    weighbridge_distance: 'Nearest Weighbridge',
    bus_stand_distance: 'Nearest Bus Stand',
    highway_distance: 'Nearest Highway',
    police_station_distance: 'Nearest Police Station',
    hospital_distance: 'Nearest Hospital',
    town_distance: 'Nearest Town',

    // warehouse_structure
    structure: 'Structure',
    truck_access: 'Truck accessible',
    built_in_year: 'Built in',
    floor: 'Flooring',
    roof: 'Roof',
    plinth_height: 'Plinth Height',
    compound_gate: 'Compound Gate',
    compound_wall: 'Compound Wall',
    main_gate_height: 'Wall height & Iron Sheet',
    no_of_door: 'No. of Doors',
    type_of_door: 'Shutter Doors',
    door_size: 'Door Size',
    no_of_ventilators: 'No. of Ventilators',
    ventilation_type: 'Ventilation Type',
    ventilation_size: 'Ventilation Size',
    window_type: 'Window Type',
    // 'Drain Pipes'
    window_size: 'Window Size',
    electric_wire: 'Electric Wiring',
    no_of_window: 'No. of Window',

    // LICENSE
    // :'Warehouse Licence'
    // :'FSSAI'
    // :'WDRA'
    // :'Storage Licence'
    // :'Procurement License'

    // WEIGHBRIDGE
    weighbridge_name: 'Weighbridge Name',
    weighbridge_address: 'Weighbridge Address',
    // calibration_certificate_verification: 'Weighbridge Certificate Date',
    // : 'Weighbridge Expiry Date',
    weighbridge_model: 'Weighbridge Model',
    weighbridge_capacity: 'Weighbridge Capacity',
    weighbridge_receipt: 'Weighbridge Receipt',
    // : 'Weighbridge Charges',
    calibration_certificate_verification: 'Calibration Verified',

    //AMENITIES
    "road": "Main Road Access",
    "lockin_key": "MINIMUM LOCKIN KEY",
    "lock_in_period": "LOCKIN PERIOD",
    "guard_room": "Guard",
    "safety_manual": "Safety Manual",
    "FIRE EXTINGUISHERS": "FIRE EXTINGUISHERS",
    "OPEN PLINTH": "OPEN PLINTH",
    "SPRINKLER SYSTEM": "SPRINKLER SYSTEM",
    "PHONE": "Phone",
    "GRADING MACHINE": "GRADING MACHINE",
    "IRON SHEET": "IRON SHEET",
    "FIRE BUCKET": "Fire Bucket",
    "ELECTRICITY": "Electricity",
    "RUNNING WATER ": "RUNNING WATER",
    "DRAIN PIPES": "DRAIN PIPES",
    "DRINKING WATER": "DRINKING WATER",
    "FIRE/SMOKE DETECTOR": "FIRE/SMOKE DETECTOR",
    "HOSES & HYDRANT": "Hydrant",
    "SAFETY SINGAGE": "Singage",
    "LOCK & KEY WITH ARYA": "Lock Key with ARYA",
    "RODENT CONTROL": "Rodent",

    // LICENSE
    "WAREHOUSE LICENSE": "WAREHOUSE LICENSE",
    "FSSAI LICENSE": "FSSAI LICENSE",
    "WDRA LICENSE": "WDRA LICENSE",
    "STORAGE LICENCE": "STORAGE LICENCE",
    "PROCUREMENT LICENSE": "PROCUREMENT LICENSE",

    'Full': "Full",
    'CHAMBER WISE': 'CHAMBER WISE',
    'PARTIAL': 'PARTIAL'
};


const weighbridge = [{
    label: "weighbridge_name",
    key: 'Weighbridge Name',
}, {
    label: "weighbridge_capacity",
    key: 'Weighbridge Capacity',
},
{
    label: "calibration_certificate_verification",
    key: 'Calibration Verified',
},
{
    label: "weighbridge_address",
    key: 'Weighbridge Address',
}, {
    label: "weighbridge_model",
    key: 'Weighbridge Model',
}, {
    label: "weighbridge_receipt",
    key: 'Weighbridge Receipt',
}
]


const structure = [{
    label: "structure",
    key: 'Structure',
},
{
    label: "truck_access",
    key: 'Truck accessible',
}, {
    label: "built_in_year",
    key: 'Built in',
}, {
    label: "floor",
    key: 'Flooring',
}, {
    label: "roof",
    key: 'Roof',
}, {
    label: "plinth_height",
    key: 'Plinth Height',
}, {
    label: "compound_gate",
    key: 'Compound Gate',
}, {
    label: "compound_wall",
    key: 'Compound Wall',
}, {
    label: "main_gate_height",
    key: 'Wall height & Iron Sheet',
}, {
    label: "no_of_door",
    key: 'No. of Doors',
}, {
    label: "type_of_door",
    key: 'Shutter Doors',
}
    , {
    label: "door_size",
    key: 'Door Size',
}
    , {
    label: "no_of_ventilators",
    key: 'No. of Ventilators',
}
    , {
    label: "ventilation_type",
    key: 'Ventilation Type',
}
    , {
    label: "ventilation_size",
    key: 'Ventilation Size',
}


    , {
    label: "window_type",
    key: 'Window Type'
}
    , {
    label: "window_size",
    key: 'Window Size',
}
    , {
    label: "electric_wire",
    key: 'Electric Wiring',
}, {
    label: "no_of_window",
    key: 'No. of Window',
}
]


const amenities = [
    { label: "road", key: "Main Road Access", },
    { label: "lockin_key", key: "MINIMUM LOCKIN KEY", },
    { label: "lock_in_period", key: "LOCKIN PERIOD", },
    { label: "guard_room", key: "Guard", },
    { label: "safety_manual", key: "Safety Manual", },




    { label: "FIRE EXTINGUISHERS", key: "FIRE EXTINGUISHERS", },
    { label: "OPEN PLINTH", key: "OPEN PLINTH", },
    { label: "SPRINKLER SYSTEM", key: "SPRINKLER SYSTEM", },
    { label: "PHONE", key: "Phone", },
    { label: "GRADING MACHINE", key: "GRADING MACHINE", },
    { label: "IRON SHEET", key: "IRON SHEET", },
    { label: "FIRE BUCKET", key: "Fire Bucket", },
    { label: "ELECTRICITY", key: "Electricity", },
    { label: "RUNNING WATER", key: "RUNNING WATER", },
    { label: "DRAIN PIPES", key: "DRAIN PIPES", },
    { label: "DRINKING WATER", key: "DRINKING WATER", },
    { label: "FIRE/SMOKE DETECTOR", key: "FIRE/SMOKE DETECTOR", },
    { label: "HOSES & HYDRANT", key: "Hydrant", },
    { label: "SAFETY SINGAGE", key: "Singage", },
    { label: "LOCK & KEY WITH ARYA", key: "Lock Key with ARYA", },
    { label: "RODENT CONTROL", key: "Rodent", },
]

export const compareConstant = {
    compareParameter, keyName, weighbridge, structure,
    amenities
};
